import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_flex _gap-1"
}
const _hoisted_2 = { class: "_flex _jc-c _ai-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_tab = _resolveComponent("base-tab")
  const _component_base_button = _resolveComponent("base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "is-visible": $props.isOpen,
    "is-processing": _ctx.isProcessing,
    icon: "user-circle",
    title: _ctx.Resources.AccountSettings.AvatarManagerModalHeader
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "#",
        class: "gfu-link gfu-link--accent",
        onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onClose && $options.onClose(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
      _createVNode(_component_base_button, {
        size: "default",
        width: "compact",
        "text-transform": "none",
        bold: true,
        theme: "accent",
        disabled: _ctx.isProcessing || !_ctx.canSave,
        onClick: _withModifiers($options.onSave, ["prevent"]),
        "data-qa": "modal-button:Save"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalSaveButton), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      ($options.avatarGeneratorEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.avatarModeTypes, (type) => {
              return (_openBlock(), _createBlock(_component_base_tab, {
                key: type.key,
                title: type.label,
                variant: "link",
                tag: "a",
                "is-active": type.isActive,
                onClick: _withModifiers($event => ($options.changeAvatarMode(type.key)), ["prevent"]),
                "data-qa": type.dataQa
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(type.label), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "is-active", "onClick", "data-qa"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock(_resolveDynamicComponent($options.activeComponent.component), _mergeProps($options.activeComponent.props, {
          onImageChanged: $options.onImageChanged,
          onAvatarChanged: $options.onAvatarChanged
        }), null, 16 /* FULL_PROPS */, ["onImageChanged", "onAvatarChanged"]))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "is-processing", "title"]))
}